export var PasswordStrength = {
    Empty: 0,
    VeryVeryWeak: 1,
    VeryWeak: 2,
    Weak: 3,
    Moderate: 4,
    Good: 5,
    Strong: 6,
    VeryStrong: 7,
};
export function measurePasswordStrength(input) {
    var strength = 0;
    if (input && typeof input === 'string') {
        if (input.length >= 5)
            strength++;
        if (input.length >= 7)
            strength++;
        if (input.length >= 9)
            strength++;
        if (input.length >= 16)
            strength++;
        if (/[0-9]/.test(input))
            strength++;
        if (/[^A-Za-z0-9]/.test(input))
            strength++;
        if (/[a-z]/.test(input) && /[A-Z]/.test(input))
            strength++;
        strength = strength || 1;
    }
    return strength;
}
